export class SchoolModuleProgress {
  maxStepIndex: number;
  isFinished: boolean;

  constructor(json: any) {
    if (json) {
      this.maxStepIndex = json.max_step_index ?? -1;
      this.isFinished = json.is_finished;
    }
    else {
      this.maxStepIndex = -1;
      this.isFinished = false;
    }
  }
}

